export const VehicleType = {
	CAR: 1,
	MOTORCYCLE: 2,
	TRUCK: 3,
	BUS: 4,
}

export const VehicleTypes = [
	{ id: VehicleType.CAR, name: 'Carro', color: '#68A357', icon:'fas fa-car' },
	{ id: VehicleType.MOTORCYCLE, name: 'Moto', color: '#2EC0F9', icon:'fas fa-motorcycle' },
	{ id: VehicleType.TRUCK, name: 'Caminhão', color: '#D8973C', icon:'fas fa-truck' },
	{ id: VehicleType.BUS, name: 'Ônibus', color: '#BA1F33', icon:'fas fa-bus-alt' },
]

export const GetVehicleTypes = ({ car, motorcycle, truck, bus }) => {
	const types = []

	if (car) {
		types.push(VehicleType.CAR)
	}

	if (motorcycle) {
		types.push(VehicleType.MOTORCYCLE)
	}

	if (truck) {
		types.push(VehicleType.TRUCK)
	}

	if (bus) {
		types.push(VehicleType.BUS)
	}

	return VehicleTypes.filter(vt => types.includes(vt.id))
}
